import { isNull } from 'lodash';
import { IDS } from '../pnp-doc.constants';
import * as PnpDocActions from '../pnp-doc.actions'
import * as PnpDocsActions from '../../pnp-docs.actions'
import watch from 'redux-watch';

/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpDocumentDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $state,$mdDialog ,$scope, $rootScope, FileActions, Notifier) {
        const unsubscribe = $ngRedux.connect(({ policies }) => ({
            pnpDocument: policies.pnpDocument
        }), {
            ...FileActions,
            ...PnpDocActions,
            ...PnpDocsActions
        })(this);

        const watchDocumentCategoryChange = watch($ngRedux.getState, 'policies.pnpDocument.documentCategory');
        const unsubscribeDocumentCategoryChange = $ngRedux.subscribe(watchDocumentCategoryChange(() => {
            if(this.pnpDocument.id){
                this.UserConfirmation({ item: { id: this.pnpDocument?.id } })
            }
        }));

        const watchLocationChange = watch($ngRedux.getState, 'policies.pnpDocument.location');
        const unsubscribeLocationChange = $ngRedux.subscribe(watchLocationChange(() => {
            if (this.pnpDocument.location)
                this.fetchReviewersContacts(this.pnpDocument.location);
                this.fetchApproversContacts(this.pnpDocument.location);
                this.getDocumentCategories(this.pnpDocument.location);
        }));

        const updateDocNum = () => {
            if(!this.pnpDocument.id){this.pnpDocument.docNum = `${this.pnpDocument.prefixName || ''} ${this.manualDocNum ||''}`.trim()}
        };
        const watchPrefixNameChange = watch($ngRedux.getState, 'policies.pnpDocument.prefixName');
        const unsubscribePrefixNameChange = $ngRedux.subscribe(watchPrefixNameChange(() => {
            updateDocNum();
        }));

        /**
         * @function $onInit
         */
        this.$onInit = () => {

            this.title = 'Upload Document'
            this.identifier = 'pnpDocument'
            this.uploadSaveBtnDisabled = false;

            this.getDocumentTypes('dms');
            this.getDocumentRiskLevels();
            this.getDocumentApplicationTypes('datype');

            this.stateIdentifier = 'pnpDocument';
            // Initialize docNum with riskDuration if available
            this.manualDocNum = ''; // Initialize manual input
            updateDocNum();

            if (this.pnpDocument.id) {

                if (this.pnpDocument?.location) {
                    this.fetchReviewersContacts(this.pnpDocument.location);
                    this.fetchApproversContacts(this.pnpDocument.location);
                    this.getDocumentCategories(this.pnpDocument.location);
                }

                this.identifier = IDS.app_policies_documents_manage;
                this.state = IDS.app_policies_documents_manage_details;
            }
            else {
                this.identifier = IDS.app_policies_documents_add;
                this.state = IDS.app_policies_documents_add_details;
            }
        }

        this.isSaving = false;

        this.onUpdateVersion = () => {
            this.getDocumentDetails(this.pnpDocument.id, true).then(() => {
            });
        };

        this.UserConfirmation = ({ item }) => {
            const confirm = $mdDialog.confirm()
                .title('Change Category')
                .textContent('Are you sure? You must remove existing reviewers/approvers before changing the category. The chosen document will be archived.')
                .ariaLabel('Archive document')
                .ok('Confirm')
                .cancel('Cancel');
            this.pnpDocument.docNum = `${this.pnpDocument.prefixName || ''} ${this.manualDocNum ||''}`.trim()
            this.dialog = $mdDialog.show(confirm).then(() => {
                Notifier.success('Document is archived successfully.');
                this.pnpDocument.selectedReviewers = [];
                this.pnpDocument.selectedApprovers= [];
            }, angular.noop);
        };

        this.onAddReviewerButton = () => {

            if (this.pnpDocument.autocompleteReviewers.some(item => item.emp_uuid === this.pnpDocument.selectedReviewer.employee_uuid)) {
                Notifier.error('COMMON.CLIENT_RESPONSE.ITEM_PRESENT_ALREADY');
                return;
            }

            if (this.pnpDocument.selectedReviewer) {
                const existingReviewer = this.pnpDocument.selectedReviewers.find((reviewer) => reviewer.emp_uuid === this.pnpDocument.selectedReviewer.employee_uuid);
                if (!existingReviewer) {
                    if (this.pnpDocumentForm.reviewerCandidateAutocomplete) {
                        this.pnpDocumentForm.reviewerCandidateAutocomplete.$setViewValue('');
                        this.pnpDocumentForm.reviewerCandidateAutocomplete.$render();
                    }
                    this.addReviewerContacts({
                        emp_uuid: this.pnpDocument.selectedReviewer.employee_uuid,
                        first_name: this.pnpDocument.selectedReviewer.first_name,
                        last_name: this.pnpDocument.selectedReviewer.last_name,
                        email: this.pnpDocument.selectedReviewer.email,
                        assignee: `${this.pnpDocument.selectedReviewer.first_name} ${this.pnpDocument.selectedReviewer.last_name}`,
                        username: this.pnpDocument.selectedReviewer.username,
                        type_name: this.pnpDocument.selectedReviewer.subject_type_name,
                    });
                }
            }
        }

        this.onRemoveReviewer = (item) => {
            this.removeReviewerContacts(item)
        }

        this.onAddApproverButton = () => {

            if (this.pnpDocument.autocompleteApprovers.some(item => item.emp_uuid === this.pnpDocument.selectedApprover.employee_uuid)) {
                Notifier.error('COMMON.CLIENT_RESPONSE.ITEM_PRESENT_ALREADY');
                return;
            }

            if (this.pnpDocument.selectedApprover) {
                const existingApprover = this.pnpDocument.selectedApprovers.find((approver) => approver.emp_uuid === this.pnpDocument.selectedApprover.employee_uuid);
                if (!existingApprover) {
                    if (this.pnpDocumentForm.approverCandidateAutocomplete) {
                        this.pnpDocumentForm.approverCandidateAutocomplete.$setViewValue('');
                        this.pnpDocumentForm.approverCandidateAutocomplete.$render();
                    }
                    this.addApporverContacts({
                        emp_uuid: this.pnpDocument.selectedApprover.employee_uuid,
                        first_name: this.pnpDocument.selectedApprover.first_name,
                        last_name: this.pnpDocument.selectedApprover.last_name,
                        email: this.pnpDocument.selectedApprover.email,
                        assignee: `${this.pnpDocument.selectedApprover.first_name} ${this.pnpDocument.selectedApprover.last_name}`,
                        username: this.pnpDocument.selectedApprover.username,
                        type_name: this.pnpDocument.selectedApprover.subject_type_name,
                    });
                }
            }
        }

        this.onRemoveApprover = (item) => {
            this.removeApproverContacts(item)
        }

        this.saveFile = (event) => {
            this.pnpDocument.path = event[0].filePath;
            this.uploadSaveBtnDisabled = false;
        }

        this.saveDetails = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.pnpDocumentForm');
            if (this.pnpDocumentForm.$valid) {
                if (!this.pnpDocument.path) {
                    Notifier.error('Please upload a file and save it');
                    return;
                }
                if (this.pnpDocument.selectedApprovers.length === 0) {
                    Notifier.error('Please add at least one approver');
                    return;
                }

                Notifier.info('Please wait...');
                this.isSaving = true;

                this.saveDocument(this.pnpDocument).then(() => {
                    this.isSaving = false;
                    this.pnpDocument.id
                        ? Notifier.success('Policy document updated successfully.')
                        : Notifier.success('New policy document saved successfully.');
                    isNull(this.pnpDocument.id) && this.resetForm();
                }).catch(() => {
                    this.isSaving = false;
                    Notifier.error('System Error!');
                });
            } else {
                Notifier.error('Please fill in the form fields');
            }
        }

        this.resetForm = () => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', '$ctrl.pnpDocumentForm');
            this.pnpDocumentForm.$setPristine();
            this.pnpDocumentForm.$setUntouched();
        };

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
            unsubscribeDocumentCategoryChange();
            unsubscribeLocationChange();
            unsubscribePrefixNameChange();
        }
    },
    template: require('./pnp-doc-details.html')
}
